export const countSpaGuests = ({ adults }: { adults: number; children?: number }) => adults;
